// istanbul ignore file
export const SERVICE_PROVIDER_NOT_MANAGED_LABEL = 'Not Managed';
export const SERVICE_PROVIDER_NOT_MANAGED_ID = 1;

export const SERVICE_PROVIDER_MANAGED_BY_LANDLORD_LABEL = 'Managed By Landlord';
export const SERVICE_PROVIDER_MANAGED_BY_LANDLORD_ID = 2;
